<div class="dynamic-form-holder">
  <form (ngSubmit)="onSubmit()" [formGroup]="form()" class="full-width">

    <h4>Add a credit for {{customerName}}:</h4>
    <p>This credit will go against all charges until it is gone. For example, if a user pays $75/mo. and you give them a $100 credit, they will receive 1 month free ($75) and then pay only $25 the next month.</p>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Amount</mat-label>
      <span matTextPrefix>$ &nbsp;</span>
      <input matInput type="number" [min]="0" [formControl]="amountControl">
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Description</mat-label>
      <input matInput type="text" [formControl]="descriptionControl">
    </mat-form-field>

    <button mat-fab extended color="secondary" type="button" (click)="dialogRef.close()">Cancel</button>
    <button mat-fab extended type="submit" [disabled]="!form().valid">Add Credit</button>

  </form>
</div>